import { IExportColumnModel } from "../../../../../shared/models";

export const TagLocationCategoriesColumnList: IExportColumnModel[] = [
]